import config from 'js/app/config';

import _t from 'i18n!nls/directory-graphql';

type ValueOf<T> = T[keyof T];

type AllResources = ReturnType<typeof getResources>;
export type ResourceName = keyof AllResources;
export type Resource = ValueOf<AllResources>;

const getResources = () =>
  ({
    articles: {
      name: 'articles',
      displayName: _t('Articles'),
    },
    degrees: {
      name: 'degrees',
      displayName: _t('Degree Programs'),
    },
    certificates: {
      name: 'certificates',
      displayName: _t('Professional Certificates'),
    },
    specializations: {
      name: 'specializations',
      displayName: _t('Specialization Programs'),
    },
    courses: { name: 'courses', displayName: _t('Courses') },
    browse: { name: 'browse', displayName: _t('Browse by category') },
    queries: { name: 'queries', displayName: _t('Popular Topics') },
    collections: { name: 'collections', displayName: _t('Collections') },
  } as const);

const resourceOrder = [
  getResources().articles,
  getResources().browse,
  getResources().collections,
  getResources().courses,
  getResources().degrees,
  getResources().queries,
  getResources().certificates,
  getResources().specializations,
];

const itemsPerPage = 35;

const exported = {
  config,
  root: '/directory',
  getResources,
  resourceOrder,
  itemsPerPage,
};

export default exported;
export { config, getResources, itemsPerPage, resourceOrder };

export const { root } = exported;
